import { verifyToken } from '../auth';
import { isProcessBlocked, setBlockedProcessMessage } from '../processes/block';
import { setSessionStart } from '../userStatus/session';
import Logger from '../logger';

const setCloserSessionStart = (roomId) => {
    const prevRoomId = window.WC._localStorage.get('roomId');
    if (!prevRoomId || prevRoomId !== roomId) {
        window.WC._localStorage.set('roomId', roomId);
        setSessionStart();
    }
};

const onUserAuthorizationSuccessHandler = (args, callbacks, authorizationResult) => {
    Logger.log('AuthorizationResultUser => ' + JSON.stringify(authorizationResult));

    const idToken = authorizationResult.idToken;
    if (idToken) {
        if (callbacks && callbacks.onAuthorized) {
            callbacks.onAuthorized(idToken);
            window.WC._localStorage.set('userStatus', 'loggedIn');
            window.WC._sessionStorage.set('isLoggedIn', true);
            window.WC._localStorage.clearAll('wc.relogin');
            if (
                isProcessBlocked({
                    processName: args.contactProcessType,
                    MOAppVersion: args.verMO
                })
            ) {
                setBlockedProcessMessage(args.contactProcessType);
                return false;
            }
        } else {
            verifyToken(idToken, (isVerified) => {
                if (!isVerified) {
                    window.WC.Closer.close('verification failed');
                }
                window.WC._localStorage.set('userStatus', 'loggedIn');
                window.WC._sessionStorage.set('isLoggedIn', true);
                window.WC._localStorage.clearAll('wc.relogin');
            });
        }
    }

    if (window._gt) {
        window._gt.push([
            'event',
            'ZZ_EVENT',
            {
                data: {
                    rule: 'Rule-431 ZZ_EVENT',
                    ZZ_eventID: 'ZZ_CloserRoomID',
                    summary: authorizationResult.roomId
                }
            }
        ]);
    }

    setCloserSessionStart(authorizationResult.roomId);

    if (window.WC?.Closer?._processTypeData) {
        const tags = Array.isArray(window.WC.Closer._processTypeData?.tags)
            ? window.WC.Closer._processTypeData.tags
            : null;

        let eventName = 'wc_chat_open';
        const eventArgs = {
            roomId: authorizationResult.roomId,
            ...(tags && {
                tags: tags.join()
            })
        };

        if (tags && tags.includes('bot')) {
            eventName = 'wc_chatbot_open';
        }

        window.WC?.sendEvent(eventName, eventArgs);
    }
};

// const onUserAuthorizationFailedHandler = (args, callbacks) => {
//     Logger.error('error -> user authorization failed');
//     window.WC.Closer._authorizationFailed = true;
//     window.closer
//         .deinit(true)
//         .finally(() => window.WC.Closer.open({ ...args, authorizationFailed: true }, callbacks));
// };

const onUserAuthorizationFailedHandler = () => {
    Logger.error('error -> user authorization failed');
    window.WC.sendEvent('wc_chat_error', { details: 'User authorization failed' });
};

export { onUserAuthorizationSuccessHandler, onUserAuthorizationFailedHandler };
